// extracted by mini-css-extract-plugin
export var imgPartenaire = "mentions-legales-module--img-partenaire--983e7";
export var mentionsContainer = "mentions-legales-module--mentions-container--cfbc3";
export var mentionsSubTitle = "mentions-legales-module--mentions-sub-title--c19c6";
export var mentionsTitle = "mentions-legales-module--mentions-title--5dd4f";
export var orderedItem = "mentions-legales-module--ordered-item--4b6e3";